import { Comment, Discussion, Identifiable, Task } from "@planzone/dto";
import { HttpClient, HttpMethods } from "@planzone/services";

function removeComment(httpClient: HttpClient) {
  return (comment: Identifiable<Comment>) =>
    httpClient.sendHttpRequest<void>({
      endpoint: `/comments/${comment.uuid}`,
      method: HttpMethods.DELETE,
    });
}

export { removeComment };
